import { t } from 'i18next';
import { toast } from 'react-toastify';
import { apiCall } from '~/providers';
import { FullProg_v4 } from '~/providers/types';

type ProgrammingV4Payload = {
  dutId: string;
} & FullProg_v4;

export async function sendProgrammingV4(payload: ProgrammingV4Payload) {
  try {
    await apiCall('/dut/set-programming-v4', {
      dutId: payload.dutId,
      automationEnabled: 'disable',
      week: {},
    });
    toast.success(t('programacaoEnviadaComSucesso'));
    return true;
  } catch (err) {
    console.log(err);
    toast.error(t('erroEnviarProgramacao'));
    return false;
  }
}
